<template>
  <div class="commission-types">
    <!-- 新增的对话框 -->
    <el-dialog
      center
      width="1000px"
      title="通知设置"
      :visible.sync="dialogTableVisible"
      @close="handleClose()"
    >
      <div class="tabsContainer" v-if="activeList.length">
        <el-tabs v-model="activeList[0]" @tab-click="handleClick">
          <el-tab-pane
            label="客服通知设置"
            name="_House_Tabs_Service"
            v-if="roleList[path].includes('_House_Tabs_Service')"
          >
            <div style="padding: 10px 0 20px">当前楼盘名：{{ houseName }}</div>
            <serviceWidget
              v-if="activeList[0] == '_House_Tabs_Service'"
              :houseId="houseId"
            />
          </el-tab-pane>
          <el-tab-pane
            label="销售通知设置"
            name="_House_Tabs_Sale"
            v-if="roleList[path].includes('_House_Tabs_Sale')"
          >
            <div style="padding: 10px 0 20px">当前楼盘名：{{ houseName }}</div>
            <saleWidget
              v-if="activeList[0] == '_House_Tabs_Sale'"
              :houseId="houseId"
            />
          </el-tab-pane>
          <el-tab-pane
            label="财务复核通知设置"
            name="_House_Tabs_Review"
            v-if="roleList[path].includes('_House_Tabs_Review')"
          >
            <div style="padding: 10px 0 20px">当前楼盘名：{{ houseName }}</div>
            <reviewWidget
              v-if="activeList[0] == '_House_Tabs_Review'"
              :houseId="houseId"
            />
          </el-tab-pane>
          <el-tab-pane
            label="财务驳回通知设置"
            name="_House_Tabs_Reject"
            v-if="roleList[path].includes('_House_Tabs_Reject')"
          >
            <div style="padding: 10px 0 20px">当前楼盘名：{{ houseName }}</div>
            <rejectWidget
              v-if="activeList[0] == '_House_Tabs_Reject'"
              :houseId="houseId"
            />
          </el-tab-pane>
          <el-tab-pane disabled>
            <span slot="label">
              <el-tooltip
                class="tooltip-item"
                effect="dark"
                placement="top-start"
              >
                <div slot="content">
                  1.客服通知：当前楼盘有客服报备成功时，系统自动推送消息给相应楼盘的所有启用状<br />态的客服人员。<br />
                  2.消息通知：客户到访分配给销售人员后，系统自动推送消息通知给被分配且状态为启<br />用状态的销售人员。
                  <br />
                  3.财务复核通知：当后台操作人添加或修改了佣金，佣金状态变为未复核同时消息通知<br />启用状态的复核人。
                  <br />
                  4.财务驳回通知：当财务经理复核发现问题，选择驳回后，佣金状态变为驳回，并通知<br />给设置的操作人。
                </div>
                <span class="el-icon-question"></span> </el-tooltip
            ></span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="no-permission" v-else>
        您没有相应的操作权限，请联系管理员。
      </div>
    </el-dialog>
  </div>
</template>
<script>
const serviceWidget = () => import('./serviceWidget'); // 客服通知设置
const saleWidget = () => import('./saleWidget'); // 销售通知设置
const reviewWidget = () => import('./reviewWidget'); // 财务驳回通知设置
const rejectWidget = () => import('./rejectWidget'); // 财务驳回通知设置
import { mapGetters } from 'vuex';

export default {
  components: {
    serviceWidget,
    saleWidget,
    reviewWidget,
    rejectWidget,
  },
  props: {},
  data() {
    return {
      dialogTableVisible: false,
      listLoading: false,
      activeName: '_House_Tabs_Service',
      activeList: [],
      houseId: '',
      houseName: '',
      path: '',
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  watch: {
    dialogTableVisible(val) {
      // console.log('dialogTableVisible', val);
      if (!val) return;
      this.activeList = [
        '_House_Tabs_Service',
        '_House_Tabs_Sale',
        '_House_Tabs_Review',
        '_House_Tabs_Reject',
      ];
      this.activeList = this.compare(this.activeList, this.roleList[this.path]);
      console.log('activeList', this.activeList);
    },
  },
  mounted() {
    // console.log('map', this.roleList[this.path]);
    // let tabList = this.roleList[this.path];
    // if (!tabList.includes('_House_Tabs_Service')) {
    //   this.activeList.splice(0, 1);
    // } else if (!tabList.includes('_House_Tabs_Sale')) {
    //   this.activeList.splice(1, 1);
    // } else if (!tabList.includes('_House_Tabs_Review')) {
    //   this.activeList.splice(2, 1);
    // } else if (!tabList.includes('_House_Tabs_Reject')) {
    //   this.activeList.splice(3, 1);
    // }
  },
  methods: {
    // 查找两个数组相同的元素
    compare(arr1, arr2) {
      return arr1.filter((v) => {
        return arr2.includes(v);
      });
    },
    // tab切换
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 关闭弹框
    handleClose() {
      // console.log('关闭弹框');
      // this.activeName = 'service';
      // this.activeList = this.compare(this.activeList, this.roleList[this.path]);
    },
  },
};
</script>
<style lang="less" scoped>
.commission-types {
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-dialog__body {
    position: relative;
    .tooltip-item {
      // position: absolute;
      // left: 55%;
      // top: 92px;
      // z-index: 10;
    }
  }
  .no-permission {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
